import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFlag = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6 22V2.8C5.99988 2.66241 6.03525 2.52713 6.10268 2.40719C6.17011 2.28726 6.26735 2.18675 6.38497 2.11537C6.50259 2.04399 6.63664 2.00415 6.77415 1.99971C6.91166 1.99527 7.048 2.02637 7.17 2.09L18.55 7.78C18.6852 7.84551 18.7993 7.9478 18.8791 8.07513C18.9589 8.20246 19.0012 8.34971 19.0012 8.5C19.0012 8.65029 18.9589 8.79754 18.8791 8.92487C18.7993 9.05221 18.6852 9.15449 18.55 9.22L6 15.5",
		stroke: "currentColor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgFlag;
